import { VideoStatus } from './VideoStatus';

const VideoStatusController = (
  reactDirective,
  $rootScope,
  CreativeService
) => {
  return reactDirective(
    VideoStatus,
    undefined,
    { restrict: 'E' },
    {
      $rootScope,
      CreativeService
    }
  );
};

VideoStatusController.$inject = [
  'reactDirective',
  '$rootScope',
  'CreativeService',
];

export default VideoStatusController;
